import React, { InputHTMLAttributes, useMemo } from 'react'
import { StyledOption as S } from './Option.styles'

export const enum OptionType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
}

export type TProps = {
  children?: React.ReactNode
  type: OptionType
  value: string
  name?: string
  disabled?: boolean
  checked?: boolean
  onChange?: (value: string, isChecked: boolean) => void
}

export const Option: React.FC<TProps> = ({
  type,
  value,
  children,
  name,
  checked,
  disabled,
  onChange,
  ...rest
}) => {
  const inputProps = useMemo((): InputHTMLAttributes<HTMLInputElement> => {
    const props: InputHTMLAttributes<HTMLInputElement> = {
      value,
      type,
      onChange: ({ target }: React.ChangeEvent<HTMLInputElement>) =>
        onChange && onChange(target.value, target.checked),
    }

    if (name) {
      props.name = name
    }

    if (checked !== undefined) {
      props.checked = checked
    }

    if (disabled) {
      props.disabled = disabled
    }

    return props
  }, [checked, disabled, name, onChange, type, value])

  return (
    <S.OptionContainer {...rest}>
      <input {...inputProps} />
      {children}
    </S.OptionContainer>
  )
}
